import React, { Fragment } from "react";
import { Col, Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import { CustomDirections, BottomLeft, BottomCenter, RightBottom, TopCenter } from "../../../Constant";
import { Btn } from "../../../AbstractElements";
import HeaderCard from "../../Common/HeaderCard";

const CustomDirectionsClass = () => {
  const directiontoaster = (toastname) => {
    switch (toastname) {
      case "directionssuccessToast":
        toast.success("Success Notification !", {
          position: "top-center",
        });
        break;
      case "directionsinfoToast":
        toast.info("Info Notification !", {
          position: "bottom-center",
        });
        break;
      case "directionswarningToast":
        toast.warn("Warning Notification !", {
          position: "bottom-left",
        });
        break;
      case "directionsdangerToast":
        toast.error("Danger Notification !", {
          position: "bottom-right",
        });
        break;
      default:
        break;
    }
  };
  return (
    <Fragment>
      <Col sm="12">
        <Card>
          <HeaderCard title={CustomDirections} />
          <CardBody className="btn-showcase">
            <Btn name="directionssuccessToast" color="success" onClick={(e) => directiontoaster(e.target.name)}>
              {TopCenter}
            </Btn>
            <Btn name="directionsinfoToast" color="info" onClick={(e) => directiontoaster(e.target.name)}>
              {BottomCenter}
            </Btn>
            <Btn name="directionswarningToast" color="warning" onClick={(e) => directiontoaster(e.target.name)}>
              {BottomLeft}
            </Btn>
            <Btn name="directionsdangerToast" color="danger" onClick={(e) => directiontoaster(e.target.name)}>
              {RightBottom}
            </Btn>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default CustomDirectionsClass;
